// mui
import { Box } from '@mui/material';

// client-shared
import { path } from '@goldblack/client-utils';

import { def } from '@goldblack/shared';

const TransparentImage = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

function PostShowMedia({ post, aspectRatio, showThumbnail, controls, blurred }) {
    const blurSx = blurred ? { filter: 'blur(20px)', transform: 'scale(1.05)' } : {};

    const imageComponent = (url) => (
        <Box
            component='img'
            src={url}
            loading='lazy'
            alt=''
            width='100%'
            height='100%'
            sx={{ display: 'block', aspectRatio, objectFit: 'cover', ...blurSx }}
        />
    );

    const videoComponent = (url) => (
        <Box
            component='video'
            src={url}
            width='100%'
            height='100%'
            muted
            controls={controls}
            autoPlay={controls}
            sx={{ display: 'block', aspectRatio, objectFit: 'cover', ...blurSx }}
        />
    );

    const thumbnailUrl = post?.thumbnail ?? null;
    const imageUrl = post?.image ?? TransparentImage;
    const isVideo = path.getContentType(imageUrl).startsWith('video');

    if (isVideo) {
        return showThumbnail && thumbnailUrl ? imageComponent(thumbnailUrl) : videoComponent(imageUrl);
    }
    return imageComponent(imageUrl);
}

function PostShowMediaProfile(post) {
    return (
        <PostShowMedia
            post={post}
            aspectRatio={1}
            showThumbnail
            blurred={post?.status === def.PostStatus.BLOCKED || post?.status === def.PostStatus.CENSORED}
        />
    );
}

function PostShowMediaDialog(post) {
    return <PostShowMedia post={post} aspectRatio='auto' controls />;
}

export { PostShowMediaProfile, PostShowMediaDialog };
